import { SxSViewState, PreviewPaneMode, WacPreviewState } from 'owa-sxsdata';
import { canLoadWacUsingJsApi } from './canLoadWacUsingJsApi';
import { isFeatureEnabled } from 'owa-feature-flags';

export function isSaveStatusSupported(viewState: SxSViewState): boolean {
    if (!viewState.previewPane) {
        return false;
    }

    if (
        isFeatureEnabled('doc-SxS-jsApi-ODB-BaseNoEditString') ||
        isFeatureEnabled('doc-SxS-jsApi-ODB-Readonly')
    ) {
        // This is a hack. Don't show save status in certain flights.
        return false;
    }

    switch (viewState.previewPane.mode) {
        case PreviewPaneMode.Wac:
            // We only support save status when wac is using JsAPI
            const wacViewState = viewState.previewPane as WacPreviewState;
            return canLoadWacUsingJsApi(wacViewState) && !wacViewState.readOnly;
        default:
            return false;
    }
}
